import { render, staticRenderFns } from "./c-image-picker.vue?vue&type=template&id=8f1d6b84&scoped=true&"
import script from "./c-image-picker.vue?vue&type=script&lang=js&"
export * from "./c-image-picker.vue?vue&type=script&lang=js&"
import style0 from "./c-image-picker.vue?vue&type=style&index=0&id=8f1d6b84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f1d6b84",
  null
  
)

export default component.exports